import { css } from '@emotion/react';

import { GrafanaTheme2 } from '@grafana/data';

export function getMarkdownStyles(theme: GrafanaTheme2) {
  return css`
    // TODO copy from _utils.scss
  `;
}
